export const PROFANITY_FILTER_DEFAULT = {
    obscureSymbol: null,
    profanityList: [],
    enabled: true,
};
